import config from 'services/table/const';
import WeightRanges from 'ui/screens/onboarding/pricing/component/weight.ranges';
import { currencyFormat } from 'utilities/common';
import Action from './table.action';

let table = { ...config };

const pricingSchema = {
  'weight_point_based': 'Berbasis Berat per Titik',
  'weight_based': 'Berbasis Berat per Kg',
  'trip_based': 'Berbasis Perjalanan',
  'colly_based': 'Berbasis Koli',
  'dedicated_monthly': 'Berbasis Dedicated Perbulan',
  'dedicated_daily': 'Berbasis Dedicated Perhari',
}

table.url = '/tms/pricing';
table.filter = { type: 'global' };
table.columns = {
  service_type: {
    title: 'Tipe Layanan',
    sortable: true,
    width: 150,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">{row?.service_type?.name}</div>
          <small className="info text-uppercase">
            {row?.service_type?.service?.name}
          </small>

        </div>
      );
    },
  },
  origin_id: {
    title: 'Asal',
    sortable: false,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <small className="info text-uppercase text-ellipsis">
            {row?.origin?.village_name
              ? `${row?.origin?.village_name}, ${row?.origin?.district_name}, ${row?.origin?.regency_name}, ${row?.origin?.province_name}`
              : row?.origin?.regency_name
                ? `${row?.origin?.regency_name}, ${row?.origin?.province_name}`
                : row?.origin?.province_name
                ? `${row?.origin?.province_name}`
                : '-'}
          </small>
        </div>
      );
    },
  },
  destination_id: {
    title: 'Tujuan',
    sortable: false,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <small className="info text-uppercase text-ellipsis">
            {row?.destination?.village_name
              ? `${row?.destination?.village_name}, ${row?.destination?.district_name}, ${row?.destination?.regency_name}, ${row?.destination?.province_name}`
              : row?.destination?.regency_name
                ? `${row?.destination?.regency_name}, ${row?.destination?.province_name}`
                : row?.destination?.province_name
                ? `${row?.destination?.province_name}`
                : '-'}
          </small>
        </div>
      );
    },
  },
  nlv: {
    title: 'Harga',
    sortable: false,
    width: 80,
    class: 'text-end',
    classHeader: 'text-end',
    component: (row) => {
      return (
        <div className="table-col">
          {row?.pricing_schema === 'weight_point_based' ? (
            <WeightRanges data={row} />
          ) : (
            <div className="text-ellipsis fs-8 fw-semibold text-uppercase">{currencyFormat(row?.nlv, false)}</div>
          )}
          <small className="info text-uppercase">
            {pricingSchema[row?.pricing_schema || row?.service_type?.pricing_schema]}
          </small>
        </div>
      )
    },
  },
  action: {
    title: '',
    width: 70,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} customer_id={row?.customer?.id} />;
    },
  },
};

export default table;
